<div class="card">
  <div class="card-header display-flex space-between">
    <h5 class="flex-start">Master Status Overview</h5>
    <div class="flex-start gap-2">
      <button class="btn btn-outline-primary" (click)="load()">
        <i class="fa fa-sync-alt"></i> Refresh
      </button>
      <button class="btn btn-primary" (click)="showTriggerModal = true">
        Trigger Process
      </button>
      <button class="btn btn-primary" (click)="openInspectModal()">Inspect</button>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body table-container">
    <table class="table table-docs table-hover">
      <thead>
        <tr>
          <th>S.N.</th>
          <ng-container *ngFor="let header of headers">
            <th *ngIf="header.id !== 'guid'">{{ header.name }}</th>
          </ng-container>
        </tr>
      </thead>

      <tbody [ngStyle]="{ display: masterStatusList.length > 0 ? 'table-row-group' : 'none' }">
        <tr *ngFor="let status of masterStatusList; let i = index">
          <td>{{ i + 1 }}</td>

          <ng-container *ngFor="let header of headers">
            <td *ngIf="header.id !== 'guid'" [ngSwitch]="header.id">

              <ng-container *ngSwitchCase="'master_account_id'">
                <a class="link-style btn" (click)="viewDetails(status.guid)">
                  {{ status[header.id] }}
                </a>
              </ng-container>

              <ng-container *ngSwitchCase="'status'">
                <span [ngClass]="getStatusClass(status[header.id])">
                  {{ status[header.id] }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'last_updated'">
                {{ status[header.id] | date: 'short' }}
              </ng-container>

              <ng-container *ngSwitchDefault>
                {{ status[header.id] ?? '-' }}
              </ng-container>

            </td>
          </ng-container>
        </tr>
      </tbody>

      <tbody [ngStyle]="{ display: masterStatusList.length == 0 ? 'table-row-group' : 'none' }">
        <tr>
          <td [attr.colspan]="headers.length">
            <div class="align-center">No Data Found</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="showInspectModal" class="modal-backdrop">
  <div class="modal-content-box">
    <div class="modal-header">
      <h5 class="modal-title">Inspect Master Summary</h5>
      <button type="button" class="btn-close" (click)="closeInspectModal()"></button>
    </div>
    <div class="modal-body">
      <app-master-summary></app-master-summary>
    </div>
  </div>
</div>

<div *ngIf="showTriggerModal" class="modal-backdrop">
  <div class="modal-content-box-t mod-w-40">
    <div class="modal-header">
      <h5 class="modal-title">Trigger Process for Master Accounts</h5>
      <button type="button" class="btn-close" (click)="closeTriggerModal()"></button>
    </div>
    <div class="modal-body-t">
      <app-trigger-process (closeModal)="closeTriggerModal()"></app-trigger-process>
    </div>
  </div>
</div>